import React, { FC } from 'react';
import { ScoreDetails } from '@/components/pages/ScoreDetails/ScoreDetails/ScoreDetails';

export const ScoreDetailsPage: FC = () => {
  return <ScoreDetails />;
};
